import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";
import {
  servicesAtomWriteOnly,
  selectedAppsAtom,
  loadableAllNodesUniqueAppsAtom,
} from "@zapier/canvas-state";

const useUpdateSelectedApps = () => {
  const [selectedApps, setSelectedApps] = useAtom(selectedAppsAtom);
  const fetchServices = useSetAtom(servicesAtomWriteOnly);
  const loadableUniqueApps = useAtomValue(loadableAllNodesUniqueAppsAtom);

  useEffect(() => {
    if (
      loadableUniqueApps.state === "loading" ||
      loadableUniqueApps.state === "hasError"
    ) {
      return;
    }

    if (loadableUniqueApps.state === "hasData") {
      const uniqueApps = loadableUniqueApps.data;

      const areArraysDifferent =
        uniqueApps.length !== selectedApps.length ||
        !uniqueApps.every((value) => selectedApps.includes(value));

      if (areArraysDifferent) {
        setSelectedApps(uniqueApps);

        if (uniqueApps.length > 0) {
          void fetchServices();
        }
      }
    }
  }, [loadableUniqueApps, setSelectedApps, selectedApps, fetchServices]);
};

export default useUpdateSelectedApps;
